import React, { PureComponent } from 'react';

class Score extends PureComponent {

  renderList() {
    let winnerRange = 0;
    for (let i = 0; i < this.props.labels.score.list.length; i += 1) {
      if (this.props.currentScore >= this.props.labels.score.list[i].range) winnerRange = i;
    }
    return this.props.labels.score.list.map((score, i) => <div key={ i } className={ winnerRange === i ? 'activated' : '' }>{ score.msg }</div>);
  }

  clicPrint = () => {
    // window.print();
    window.open(this.props.labels.score.PDF);
  }

  renderIconPrint() {
    return (
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="print" className="svg-inline--fa fa-print fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"></path></svg>
    );
  }

  render() {
    return (
      <div className="score animated zoomIn">
        <div className="score-title">{ this.props.labels.score.title } <span>{ this.props.currentScore }</span></div>

        {/*
        <div className="score-text">
        { this.props.labels.score.subtitle }
        <div className="score-list">
        { this.renderList() }
        </div>
        </div>
        */}

        <div className="score-avis">
          <div className="score-avis_img"><img src={ this.props.labels.score.avis.img } /></div>
          <div className="score-avis_right">
            <span className="score-avis_title">{ this.props.labels.score.avis.title }</span>
            <div dangerouslySetInnerHTML={{ __html: this.props.currentScore < 3 ? this.props.labels.score.avis.text : this.props.labels.score.avis.text2 }} />
          </div>
        </div>
        <div className="score-mention" dangerouslySetInnerHTML={{ __html: this.props.labels.score.mentions }}></div>
        <div className="score-buttons">
          <button onClick={ this.props.clicRestart }><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="redo" className="svg-inline--fa fa-redo fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"></path></svg> { this.props.labels.score.button }</button>
          <span onClick={ this.clicPrint }>{ this.renderIconPrint() }</span>
        </div>
        <div className="score-buttons_mobile">
          <span onClick={ this.clicPrint }>{ this.renderIconPrint() }</span>
        </div>
      </div>
    );
  }
}

export default Score;



// WEBPACK FOOTER //
// ./src/components/score.js